import React from 'react'

import { Divider, Input } from '@st-operations/uikit/src/v2'

const RecommendedSegmentsSignals = ({ slide, field, index, onFieldChange }) => {
  const data = slide.data.section_3

  const content = new Array(5).fill(null).map((_, i) => ({
    name: `signal_${i + 1}`,
    value: data[`signal_${i + 1}`] ?? '',
  }))

  const handleChange = (value, name) => {
    onFieldChange({ index, value, type: name, field })
  }

  return (
    <>
      <Divider className="selected-entities-editor__divider" />
      <p className="st-select__label">Custom Signals</p>
      {content.map(({ name, value }) => (
        <Input key={name} name={name} onChange={handleChange} value={value} />
      ))}
    </>
  )
}

export default RecommendedSegmentsSignals
